
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconPinSelector = "fhi-icon-pin";

/**
 * ## FhiIconPin
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-pin
 * @element fhi-icon-pin
 */
@customElement(FhiIconPinSelector)
export class FhiIconPin extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M16 1.25a2.75 2.75 0 0 1 0 5.5.25.25 0 0 0-.25.25v3.76l.012.173a1.25 1.25 0 0 0 .681.945l.005.003 1.78.9a2.75 2.75 0 0 1 1.522 2.458V16A1.75 1.75 0 0 1 18 17.75h-5.25V22a.75.75 0 0 1-1.5 0v-4.25H6A1.75 1.75 0 0 1 4.25 16v-.76l.007-.192A2.75 2.75 0 0 1 5.77 12.78l1.78-.9.006-.002a1.25 1.25 0 0 0 .681-.945l.012-.173V7A.25.25 0 0 0 8 6.75a2.75 2.75 0 0 1 0-5.5zm-8 1.5a1.25 1.25 0 0 0 0 2.5A1.75 1.75 0 0 1 9.75 7v3.76a2.75 2.75 0 0 1-1.522 2.459l-1.78.9-.005.003a1.25 1.25 0 0 0-.693 1.118V16a.25.25 0 0 0 .25.25h12a.25.25 0 0 0 .25-.25v-.76a1.25 1.25 0 0 0-.693-1.118l-.005-.003-1.78-.9a2.75 2.75 0 0 1-1.522-2.458V7A1.75 1.75 0 0 1 16 5.25a1.25 1.25 0 0 0 0-2.5z"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
